import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { NikoDocumentationRequestEmailEditTemplate } from 'themes/application/niko-facility-order-clinical-review/pages';
import { NikoDocumentationRequestEmailEditViewStore } from 'application/niko-facility-order-clinical-review/stores';

@setCurrentView((rootStore) => new NikoDocumentationRequestEmailEditViewStore(rootStore), 'nikoDocumentationRequestEmailEditViewStore')
@observer
class NikoDocumentationRequestEmailEdit extends React.Component {
    render() {
        return <NikoDocumentationRequestEmailEditTemplate {...this.props} />
    }
}

export default NikoDocumentationRequestEmailEdit;
